const AUTOMATIC_CROSS_SELLING_CATEGORY_KEYWORDS = {
    pl: [
        "alkohol",
        "bajgle",
        "bezalkoholowe",
        "bułeczki",
        "bułeczka",
        "bułka",
        "bułki",
        "buły",
        "buła",
        "ciasta",
        "ciasto",
        "deser",
        "dodatki",
        "dodatkowe",
        "dodatek",
        "dressing",
        "drink",
        "finger",
        "frytki",
        "herbata",
        "herbaty",
        "kawa",
        "kawy",
        "koktajle",
        "lemoniady",
        "lemoniada",
        "nachos",
        "napoje",
        "napój",
        "oliwy",
        "oliwa",
        "owoców",
        "owocow",
        "pancake",
        "pieczywo",
        "piwa",
        "piwo",
        "przekąski",
        "przystawki",
        "sałatka",
        "sałatki",
        "sałaty",
        "smoothie",
        "soki",
        "sosy",
        "starter",
        "surówka",
        "surówki",
        "słodkie",
        "słodko",
        "słodkości",
        "tapas",
        "wina",
        "wino",
        "wypieki",
        "zakąski",
    ],
    en: [
        "alcohol",
        "bagels",
        "non-alcoholic",
        "buns",
        "bun",
        "roll",
        "rolls",
        "cakes",
        "dough",
        "pastry",
        "cake",
        "dessert",
        "sides",
        "toppings",
        "additional",
        "side dish",
        "add-on",
        "dressing",
        "drink",
        "finger food",
        "fries",
        "tea",
        "teas",
        "coffee",
        "coffees",
        "cocktails",
        "lemonades",
        "lemonade",
        "nachos",
        "beverages",
        "drinks",
        "beverage",
        "drink",
        "olive oils",
        "olive oil",
        "fruits",
        "pancake",
        "bread",
        "beers",
        "beer",
        "snacks",
        "appetizers",
        "starters",
        "salad",
        "salads",
        "lettuces",
        "smoothie",
        "juices",
        "sauces",
        "starter",
        "salad",
        "slaw",
        "sweet",
        "sweetly",
        "tapas",
        "wines",
        "wine",
        "baked goods",
        "snacks",
        "side dishes",
        "cookies",
        "nibble",
        "snack",
        "crisps",
        "chips",
        "sauces",
    ],
    cs: [
        "alkohol",
        "pečivo",
        "nealkoholické",
        "buchty/housky",
        "houska",
        "rohlík",
        "rohlíky",
        "koláče",
        "těsto",
        "pečivo",
        "dort",
        "moučník",
        "přílohy",
        "topingy",
        "další",
        "příloha",
        "přídavek",
        "dresink",
        "zálivka",
        "nápoj",
        "hranolky",
        "čaj",
        "čaje",
        "káva",
        "kafe",
        "kávy",
        "koktejly",
        "limonády",
        "limonáda",
        "nachos",
        "nápoje",
        "pití",
        "nápoj",
        "pití",
        "olivové oleje",
        "olivový olej",
        "ovoce",
        "palačinka",
        "chléb",
        "piva",
        "pivo",
        "občerstvení",
        "předkrmy",
        "salát",
        "saláty",
        "smoothie",
        "koktejl",
        "džusy",
        "omáčky",
        "předkrm",
        "salát ze syrové zeleniny",
        "syrové zeleninové saláty",
        "sladké",
        "sladce",
        "sladkosti",
        "sladké pochoutky",
        "tapas",
        "vína",
        "víno",
        "pečivo",
        "občerstvení",
        "přílohy",
        "utopenec",
        "nakládaný hermelín",
        "vepřové koleno",
        "topinka",
        "bramborák",
        "škvarky",
        "česnečka",
    ],
    sk: [
        "alkohol",
        "pečivo",
        "nealkoholické",
        "žemle",
        "žemľa",
        "rožok",
        "rožky",
        "veľké rožky",
        "veľký rožok",
        "koláče",
        "cesto",
        "pečivo",
        "koláč",
        "dezert",
        "prílohy",
        "topingy",
        "ďalšie",
        "príloha",
        "dresing",
        "nápoj",
        "hranolky",
        "čaj",
        "čaje",
        "káva",
        "kávy",
        "koktaily",
        "limonády",
        "limonáda",
        "nachos",
        "nápoje",
        "nápoj",
        "drink",
        "olivové oleje",
        "olivový olej",
        "ovocie",
        "palacinka",
        "chieb",
        "pivá",
        "pivo",
        "občerstvenie",
        "predjedlá",
        "predkrmy",
        "šalát",
        "šaláty",
        "šaláty",
        "smoothie",
        "džúsy",
        "omáčky",
        "predjedlo",
        "šalát zo surovej zeleniny",
        "sladké",
        "sladké",
        "sladkosti",
        "sladké pochúťky",
        "tapas",
        "vína",
        "víno",
        "pečivo",
        "občerstvenie",
        "prílohy",
        "oškvarky",
        "nakladaný hermelín",
        "bryndzové halušky",
        "zemiakové placky",
        "klobáska",
        "škvarková nátierka",
    ],
    hr: [
        "alkohol",
        "peciva",
        "bezalkoholno",
        "lepinje",
        "lepinja",
        "kifla",
        "kifle",
        "velike kifle",
        "velika kifla",
        "kolači",
        "tijesto",
        "pecivo",
        "kolač",
        "desert",
        "dodaci",
        "preljevi",
        "doadaci",
        "prilog",
        "dodatak",
        "dressing",
        "piće",
        "fingerfood",
        "pomfrit",
        "čaj",
        "čajevi",
        "kava",
        "kave",
        "kokteli",
        "limunade",
        "limunada",
        "nachos",
        "napitci",
        "pića",
        "napitak",
        "piće",
        "maslinova ulja",
        "maslonovo ulje",
        "voće",
        "palačinka",
        "kruh",
        "piva",
        "pivo",
        "grickalice",
        "predjela",
        "salata",
        "salate",
        "zelene salate",
        "smoothie",
        "sokovi",
        "umaci",
        "predjelo",
        "salata",
        "salata od sirovog povrća",
        "salate",
        "salate od sirovog povrća",
        "slatko",
        "slatko",
        "slatkiši",
        "slatke poslastice",
        "tapas",
        "vina",
        "vino",
        "peciva",
        "grickalice",
        "prilozi",
        "pršut",
        "paški sir",
        "ajvar",
        "kulen",
        "burek",
        "čvarci",
        "sardine na žaru",
    ],
    ro: [
        "alcool",
        "covrigi",
        "non-alcoolice",
        "fară alcool",
        "chifle",
        "chiflă",
        "rulou",
        "rulouri",
        "rulouri mari",
        "rulou mare",
        "prăjituri",
        "aluat",
        "patiserie",
        "prăjitură",
        "desert",
        "garnituri",
        "topping-uri",
        "suplimentar",
        "garnitură",
        "adauga",
        "dressing",
        "băutură",
        "cartofi prăjiți",
        "ceai",
        "ceaiuri",
        "cafea",
        "cafele",
        "cocktailuri",
        "limonade",
        "limonadă",
        "nachos",
        "băuturi",
        "băutură",
        "uleiuri de măsline",
        "ulei de măsline",
        "fructe",
        "clătite pufoase",
        "clătite",
        "pâine",
        "beri",
        "bere",
        "gustări",
        "aperitive",
        "antreu",
        "salată",
        "salate",
        "salata verde",
        "smoothie",
        "sucuri",
        "sosuri",
        "antreu",
        "salată de legume crude",
        "raw vegetable salads",
        "slaws -salată de legume crude",
        "dulce",
        "dulce",
        "dulciuri",
        "gustari dulci",
        "tapas",
        "vinuri",
        "vin",
        "produse de patiserie",
        "gustarii",
        "garnituri",
        "mici",
        "mititei",
        "zacuscă",
        "ciorbă mică",
        "slanină cu ceapă",
        "cârnați afumați",
        "covrigi calzi",
        "gogoși",
    ],
};
export function automaticCrossSellingCategoryFilter(
/**
 * Locale in which (we assume) category names are written.
 * This is not the current locale, as category names are internal; rather the default account locale.
 */
defaultLocale, categoryName) {
    const lowerCaseCategoryName = categoryName.toLowerCase();
    if (!(defaultLocale in AUTOMATIC_CROSS_SELLING_CATEGORY_KEYWORDS)) {
        // Locale not supported
        return false;
    }
    const keywords = AUTOMATIC_CROSS_SELLING_CATEGORY_KEYWORDS[defaultLocale];
    return keywords.some((keyword) => lowerCaseCategoryName.includes(keyword));
}
